import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=00ff21e8&scoped=true"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"
import style0 from "./TextareaField.vue?vue&type=style&index=0&id=00ff21e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff21e8",
  null
  
)

export default component.exports